// extracted by mini-css-extract-plugin
export default {"StripeElement":"_5D1Kheyz","StripeElement--focus":"_5D3o_g5v","StripeElement--invalid":"_5D2Yjn2J","StripeElement--webkit-autofill":"_5D3ceRfV"};